import React from 'react';
import { AcuityContextProvider } from './AcuityContextProvider';

export type AcuityProviderProps = React.PropsWithChildren<{}>;

export const AcuityProvider: React.FC<AcuityProviderProps> = ({ children }) => {
  const [showAcuityDialog, setShowAcuityDialog] = React.useState(false);

  const handleShowAcuityDialog = React.useCallback(() => {
    setShowAcuityDialog(true);
  }, [setShowAcuityDialog]);

  const handleHideAcuityDialog = React.useCallback(() => {
    setShowAcuityDialog(false);
  }, [setShowAcuityDialog]);

  return (
    <>
      <AcuityContextProvider
        value={{
          setShowAcuityDialog: handleShowAcuityDialog,
          showAcuityDialog,
          setHideAcutiyDialog: handleHideAcuityDialog,
        }}
      >
        {children}
      </AcuityContextProvider>
    </>
  );
};
